/* tslint:disable */

/**
 */
export class RpOutputForm {
    from_date?: string;
    to_date?: string;
    vehicle_id?: number;
}
